import PackageRequestsStandTable from "./package-requests-stand-table";

export default PackageRequestsStandTable;
